// extracted by mini-css-extract-plugin
module.exports = {"page":"Editorial_page__3fjjp","title":"Editorial_title__1jnrg","content":"Editorial_content__3Qc-3"};